import { useQuery } from '@tanstack/react-query';
import { getRunsWithActivities } from '../services/IIMRunsService';
import { iimReviewKeys } from './queryKeys';
/**
 * Custom hook to fetch IIM runs with their activities for a specific inspection
 * @param inspectionId - The ID of the inspection to fetch runs for
 * @param options - Optional query configuration options
 * @returns UseQueryResult with IIM runs and activities data
 */
export default function useIIMRuns(inspectionId, options) {
    return useQuery({
        queryKey: iimReviewKeys.runs(inspectionId),
        queryFn: () => getRunsWithActivities(inspectionId),
        staleTime: 30000,
        enabled: (options === null || options === void 0 ? void 0 : options.enabled) !== false
    });
}
